import React, { use, useEffect, useiState, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom'
import { UserDetailSlice } from '../../../../redux/features/UserManagementSlice';
import { toast } from 'react-toastify';

const PersonalDetails = () => {

  const [iState,setUpdate] = useState({});

  const {userDetails} = useSelector((state) => state.UserManagement);

  useEffect(()=>{
    if(userDetails && Object.keys(userDetails).length > 0){
      setUpdate(userDetails);
    }
  },[userDetails])

  return (
    <>
     <div className="row">
  <div className="col-sm-5">
    <div className="Small-Wrapper">
      <div className="CommonForm">
        <div className="form-group">
          <label>Full Name</label>
          <input
            type="text"
            disabled={true}
            className="form-control"
            placeholder=""
            value={iState?.name}
          />
        </div>
        <div className="form-group">
          <label>Preferred Language</label>
          <input
            type="text"
            disabled={true}
            value={iState?.preferLanguage}
            className="form-control"
            placeholder=""
          />
        </div>
        {iState?.phoneNumber &&
        <div className="form-group">
          <label>Mobile Number</label>
          <input
            type="number"
            disabled={true}
            value={iState?.phoneNumber}
            className="form-control"
            placeholder=""
          />
        </div>
}

        {iState?.email &&
        <div className="form-group">
          <label>Email</label>
          <input
            type="email"
            disabled={true}
            value={iState?.email}
            className="form-control"
            placeholder=""
          />
        </div>
}
        <div className="form-group">
          <label>iState</label>
          <input
            type="text"
            disabled={true}
            value={iState?.meraGaon}
            className="form-control"
            placeholder=""
          />
        </div>
        <div className="form-group">
          <label>City/District</label>
          <input
            type="text"
            disabled={true}
            value={iState?.city}
            className="form-control"
            placeholder=""
          />
        </div>
      </div>
    </div>
  </div>
</div>
 
    </>
  )
}

export default PersonalDetails
